import { AcceptInvitationPage } from './AcceptInvitationPage';
import { withAcceptInvitationPage } from './withAcceptInvitationPage';

const ConnectedAcceptInvitationPage = withAcceptInvitationPage(
  AcceptInvitationPage
);

export { ConnectedAcceptInvitationPage as AcceptInvitationPage };
